"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-ns-register-prompt"
  }, [_vm._v(" 🔔 Pour discuter sur le salon "), _c('span', {
    staticClass: "app-ns-register-prompt-chan"
  }, [_vm._v(_vm._s(_vm.channel))]), _vm._v(", ton pseudo doit être enregistré ➔ "), _c('a', {
    staticClass: "app-ns-register-prompt-badge",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.openRegister.apply(null, arguments);
      }
    }
  }, [_vm._v("Enregistrer mon pseudo")])]);
};
var staticRenderFns = exports.staticRenderFns = [];